import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import {CreelMap} from '@domain/textile-data/creel/creel-map';
import {OverviewListColoredYarnSetWithStartDent} from '@domain/textile-data/creel/overview-list-colored-yarn-set-with-start-dent';
import {PreviewType} from '@presentation/pages/textile-data/creel/add/preview-type';

@Component({
  selector: 'app-colored-yarn-set-map-card',
  templateUrl: './colored-yarn-set-map-card.component.html',
  styleUrls: ['./colored-yarn-set-map-card.component.scss']
})
export class ColoredYarnSetMapCardComponent {
  @Input() public coloredYarnSetWithStartDent: OverviewListColoredYarnSetWithStartDent;
  @Input() public activeColoredYarnSetCreelMap: CreelMap;
  @Output() public activeColoredYarnSetCreelMapChange: EventEmitter<CreelMap> = new EventEmitter<CreelMap>();

  public previewType: PreviewType = PreviewType.COLOR;

  public onPreviewTypeChange(event: MatSlideToggleChange): void {
    this.previewType = event.checked ? PreviewType.YARN_TYPE : PreviewType.COLOR;
  }

  public updateCreelMap(creelMap: CreelMap): void {
    this.activeColoredYarnSetCreelMapChange.emit(creelMap);
  }
}
